import React from 'react';
import {Link} from 'react-router-dom';

import Framework from "@beardeddevops/react.framework";
import {Card, CardContent} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import {Modal, ModalBody} from "reactstrap";
import API from "@beardeddevops/react.api";
import Types from "../../../../../constants/Types";
import {confirmAlert} from "react-confirm-alert";
import {toast} from "react-toastify";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Invoices',
		url: '/invoices',
		icon: 'file-text-o',
	}
];

const STATUS_LABELS = {
	0: "Open",
	1: "Paid",
	2: "Written Off",
};

class Invoice extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.invoice = null;
		this.state.newNote = '';
		this.state.savingNote = false;
		this.state.sendingInvoice = false;
		this.state.updateEmailModal = false;
		this.state.receiptEmailDraft = '';
		this.paymentsRef = React.createRef();
	}

	componentDidMount() {
		this.loadInvoice();
	}

	loadInvoice = async () => {
		try {
			let model = new API.BuildClass(Types.Invoices._name, API.RequestType.READ);
			model.object = {pkey: this.props.id};
			let data = await model.submit(null, 'GET', true);
			let invoice = data?.response ?? data?.object ?? data;
			this.setState({invoice});
		} catch (error) {
			// leave invoice null; UI shows a not-found state
		}
	};

	handleAfterSave = () => {
		this.setState({key: Math.random(), newNote: ''});
		this.loadInvoice();
	};

	handleNoteChange = (event) => {
		this.setState({newNote: event.target.value});
	};

	handleAddNote = async () => {
		const note = (this.state.newNote || '').trim();
		if (!note) {
			return;
		}
		this.setState({savingNote: true});
		try {
			let model = new API.BuildClass(Types.Invoices._name, API.RequestType.UPDATE);
			model.object = {pkey: this.props.id, note: note};
			let data = await model.submit(null, 'POST_NOTES', true);
			let payload = data?.response ?? data?.object ?? data;
			if (payload?.invoice_notes) {
				this.setState({
					invoice: {...this.state.invoice, invoice_notes: payload.invoice_notes},
					newNote: '',
				});
			} else {
				this.setState({newNote: ''});
				this.loadInvoice();
			}
		} catch (error) {
		} finally {
			this.setState({savingNote: false});
		}
	};

	invoiceAmountDue = (invoice) => {
		if (!invoice) {
			return 0;
		}
		const hasInvoiceStatus = invoice.invoice_status != null && invoice.invoice_status !== '';
		if (hasInvoiceStatus) {
			return parseFloat(invoice.invoice_remaining ?? 0);
		}

		return parseFloat(invoice.invoice_amount ?? 0);
	};

	invoiceReceiptEmail = (invoice) => {
		if (!invoice) {
			return '';
		}
		if (invoice.receipt_email) {
			return invoice.receipt_email;
		}
		if (invoice.customers && invoice.customers.email) {
			return invoice.customers.email;
		}
		return '';
	};

	openSendInvoiceEmailModal = (invoice) => {
		this.setState({
			updateEmailModal: true,
			receiptEmailDraft: this.invoiceReceiptEmail(invoice),
		});
	};

	submitSendInvoice = async (transactionId) => {
		const model = new API.BuildClass(Types.Transactions._name, API.RequestType.UPDATE);
		model.object = {pkey: transactionId};
		await model.submit(null, "POST_INVOICE_SEND", true);
		toast.success("Invoice sent.", {position: toast.POSITION.TOP_CENTER});
		await this.loadInvoice();
	};

	handleSendInvoice = async () => {
		const invoice = this.state.invoice;
		const rootState = this.props.rootState || {};
		const amountDue = this.invoiceAmountDue(invoice);
		if (!rootState.invoicing_enabled || !rootState.pay_by_link_enabled || !rootState.altrupay_linked || amountDue <= 0) {
			return;
		}

		const transactionId = invoice?.pkey || this.props.id;
		if (!transactionId) {
			return;
		}

		if (!invoice?.receipt_email) {
			this.openSendInvoiceEmailModal(invoice);
			return;
		}

		this.setState({sendingInvoice: true});
		try {
			await this.submitSendInvoice(transactionId);
		} catch (error) {
			const message = error && error.responseJSON && error.responseJSON.response
				? error.responseJSON.response
				: (error?.message || "Unable to send invoice.");
			toast.error(message, {position: toast.POSITION.TOP_CENTER});
		} finally {
			this.setState({sendingInvoice: false});
		}
	};

	handleSendInvoiceEmailConfirm = async () => {
		const invoice = this.state.invoice;
		const transactionId = invoice?.pkey || this.props.id;
		const receiptEmail = (this.state.receiptEmailDraft || '').trim();
		if (!transactionId || !receiptEmail) {
			return;
		}

		this.setState({sendingInvoice: true});
		try {
			let transaction = new API.BuildClass(Types.Transactions._name, API.RequestType.UPDATE);
			transaction.object = {
				pkey: transactionId,
				receipt_email: receiptEmail,
			};
			await transaction.submit(null, 'POST_UPDATE_EMAIL', true);
			this.setState({
				updateEmailModal: false,
				invoice: {...invoice, receipt_email: receiptEmail},
			});
			await this.submitSendInvoice(transactionId);
		} catch (error) {
			const message = error && error.responseJSON && error.responseJSON.response
				? error.responseJSON.response
				: (error?.message || "Unable to send invoice.");
			toast.error(message, {position: toast.POSITION.TOP_CENTER});
		} finally {
			this.setState({sendingInvoice: false});
		}
	};

	handleWriteOff = () => {
		confirmAlert({
			title: 'Write Off Invoice',
			message: 'Are you sure you want to write this Invoice off? In the future if the customer pays, you will still be able to add that towards this invoice.',
			buttons: [
				{
					label: 'Yes, write it off',
					onClick: async () => {
						try {
							let model = new API.BuildClass(Types.Invoices._name, API.RequestType.UPDATE);
							model.object = {pkey: this.props.id, notes: 'Written off from invoice view.'};
							await model.submit(null, 'POST_WRITEOFF');
							this.handleAfterSave();
						} catch (error) {
						}
					}
				},
				{
					label: 'Cancel',
					onClick: () => {
					}
				}
			]
		});
	};

	render() {
		const invoice = this.state.invoice;
		const status = invoice ? parseInt(invoice.invoice_status) : null;
		const remaining = invoice ? parseFloat(invoice.invoice_remaining ?? 0) : 0;
		const isOpen = status === 0;
		const canCollect = status === 0 || status === 2;
		const rootState = this.props.rootState || {};
		const amountDue = this.invoiceAmountDue(invoice);
		const showSendInvoice = rootState.invoicing_enabled
			&& rootState.pay_by_link_enabled
			&& rootState.altrupay_linked
			&& amountDue > 0;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: `Invoice #${this.props.id}`,
				url: `/invoices/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					{invoice &&
						<Link to={`/transactions/${invoice.pkey}`}>
							<Button size={"sm"} color="info" style={{ borderRadius: '6px' }}>
								<i className="fa fa-shopping-cart"/>&nbsp;&nbsp;To Transaction
							</Button>
						</Link>}
					{showSendInvoice &&
						<Button className="primary-button"
							size={"sm"}
							onClick={this.handleSendInvoice}
							disabled={this.state.sendingInvoice}
						>
							<i className="fa fa-envelope"/>&nbsp;&nbsp;Send Invoice
						</Button>}
					{canCollect &&
						<Button data-id="receive-payment" onClick={this.toggle('modalPayment')} size={"sm"} className="primary-button">
							<i className="fa fa-usd"/>&nbsp;&nbsp;Receive Payment
						</Button>}
					{isOpen &&
						<Button size={"sm"} className='danger-button' color="danger" onClick={this.handleWriteOff}>
							<i className="fa fa-ban"/>&nbsp;&nbsp;Write Off
						</Button>}
				</Framework.Components.PageBar>

				<Card>
					<CardContent>
						{invoice ?
							<div className={'row'}>
								<div className={'col-md-4'}>
									<h4 className="section-title">Invoice #{invoice.pkey}</h4>
									<p><b>Status:</b> {STATUS_LABELS[status] ?? '-'}</p>
									<p><b>Customer:</b> {invoice.customers ? invoice.customers.name : invoice.client}</p>
								</div>
								<div className={'col-md-4'}>
									<h4 className="section-title">Amounts</h4>
									<p><b>Transaction Total:</b> ${parseFloat(invoice.amount ?? 0).toFixed(2)}</p>
									<p><b>Invoiced:</b> ${parseFloat(invoice.invoice_amount ?? 0).toFixed(2)}</p>
									<p><b>Remaining:</b> ${remaining.toFixed(2)}</p>
								</div>
								<div className={'col-md-4'}>
									<h4 className="section-title">Notes</h4>
									{invoice.invoice_notes ?
										<p style={{whiteSpace: 'pre-wrap', marginBottom: 15}}>{invoice.invoice_notes}</p>
										: null}
									<div className={"form-group"}>
										<TextField
											label="Add Note"
											value={this.state.newNote}
											onChange={this.handleNoteChange}
											multiline
											fullWidth
											variant="outlined"
											margin="dense"
										/>
									</div>
									<Button className="primary-button"
										size={"sm"}
										onClick={this.handleAddNote}
										disabled={this.state.savingNote || !(this.state.newNote || '').trim()}
									>
										<i className="fa fa-plus"/>&nbsp;&nbsp;Add Note
									</Button>
								</div>
							</div>
							:
							<div>Loading invoice...</div>
						}
					</CardContent>
				</Card>

				<Card style={{marginTop: 15}}>
					<CardContent>
						<h4 className="section-title">Payment History</h4>
						<Collections.InvoicePayments
							key={this.state.key}
							ref={this.paymentsRef}
							parent={this.props.id}
							history={this.props.history}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
						/>
					</CardContent>
				</Card>

				<Framework.Elements.UniversalModal
					parent={this.props.id}
					locations={this.props.locations}
					name={"Invoice"}
					title={'Receive Payment'}
					submitLabel={'Submit Payment'}
					object={Objects.InvoicePayment}
					objectProps={{
						paymentModel: Types.Invoices_Payments._name,
						remaining: remaining.toFixed(2),
					}}
					history={this.props.history}
					toggle={this.state['modalPayment']}
					reportClose={this.reportClose('modalPayment')}
					afterSave={this.handleAfterSave}
					size={'lg'}
					project={'pos'}
				/>

				<Modal
					isOpen={this.state.updateEmailModal}
					toggle={() => {this.setState({updateEmailModal: false})}}
					size={"md"}
					backdrop={true}
				>
					<ModalBody>
						<div className={'d-flex flex-column'}>
							<b style={{justifySelf: "center", paddingBottom: '1rem'}}>
								This transaction is missing an email to send the invoice to. Please fill that out below.
							</b>
							<TextField
								value={this.state.receiptEmailDraft}
								onChange={(event) => {this.setState({receiptEmailDraft: event.currentTarget.value})}}
								fullWidth={true}
								size={"small"}
								label={"Email"}
								variant={'outlined'}
							/>
							<div className={'justify-content-between full-width d-flex py-1'}>
								<Button
									color={'danger'}
									size={"sm"}
									block={false}
									onClick={() => {this.setState({updateEmailModal: false})}}
								>
									Cancel
								</Button>
								<Button
									color={'success'}
									size={"sm"}
									block={false}
									onClick={this.handleSendInvoiceEmailConfirm}
									disabled={this.state.sendingInvoice || !(this.state.receiptEmailDraft || '').trim()}
								>
									Update and Send
								</Button>
							</div>
						</div>
					</ModalBody>
				</Modal>
			</div>
		);
	}
}

export default Framework.Components.withRootState(Invoice);
